import { createContext, useState } from "react";

export const ForgottenPasswordContext = createContext({
  openForgottenPasswordModal: false,
  setOpenForgottenPasswordModal: () => false,
});

export const ForgottenPasswordProvider = ({ children }) => {
  const [openForgottenPasswordModal, setOpenForgottenPasswordModal] =
    useState(false);
  const value = { openForgottenPasswordModal, setOpenForgottenPasswordModal };
  return (
    <ForgottenPasswordContext.Provider value={value}>
      {children}
    </ForgottenPasswordContext.Provider>
  );
};
